export default __webpack_public_path__ + "static/media/iron.26eb6419.jpg";